import React from 'react';

interface PricingTableProps {
  onSelectTier?: (tier: 'Starter' | 'Pro' | 'Team') => void;
  selectedTier?: string;
  compact?: boolean;
}

const tiers = [
  {
    name: 'Starter' as const,
    price: '$999',
    priceNote: 'per student',
    description: 'Perfect for individual learners ready to advance their security career.',
    features: [
      '1 course enrollment',
      '1 student seat',
      'Live instructor-led training',
      'Hands-on lab environment',
      'Course completion certificate',
      'Digital courseware access (90 days)',
      'Email support',
    ],
    highlight: false,
  },
  {
    name: 'Pro' as const,
    price: '$2,499',
    priceNote: 'per student',
    description: 'Best value for professionals pursuing multiple certifications.',
    features: [
      'Unlimited course enrollments',
      '1 student seat',
      'Live instructor-led training',
      'Hands-on lab environment',
      'Course completion certificates',
      'Digital courseware access (1 year)',
      'Priority email & chat support',
      'Exam prep resources',
    ],
    highlight: true,
  },
  {
    name: 'Team' as const,
    price: '$4,999',
    priceNote: 'up to 10 students',
    description: 'Ideal for teams building Microsoft security expertise together.',
    features: [
      'Unlimited course enrollments',
      'Up to 10 student seats',
      'Live instructor-led training',
      'Hands-on lab environment',
      'Course completion certificates',
      'Digital courseware access (1 year)',
      'Dedicated account manager',
      'Priority support',
      'Team progress dashboard',
      'Custom scheduling available',
    ],
    highlight: false,
  },
];

const PricingTable: React.FC<PricingTableProps> = ({ onSelectTier, selectedTier, compact }) => {
  return (
    <div className={`pricing-table ${compact ? 'pricing-compact' : ''}`}>
      {tiers.map((tier) => (
        <div
          key={tier.name}
          className={`pricing-card ${tier.highlight ? 'pricing-highlight' : ''} ${
            selectedTier === tier.name ? 'pricing-selected' : ''
          }`}
        >
          {tier.highlight && <div className="pricing-badge">Most Popular</div>}
          <h3 className="pricing-tier-name">{tier.name}</h3>
          <div className="pricing-price">
            <span className="pricing-amount">{tier.price}</span>
            <span className="pricing-note">{tier.priceNote}</span>
          </div>
          <p className="pricing-description">{tier.description}</p>
          <ul className="pricing-features">
            {tier.features.map((feature, index) => (
              <li key={index} className="pricing-feature">
                <span className="pricing-check">&#10003;</span>
                {feature}
              </li>
            ))}
          </ul>
          {onSelectTier && (
            <button
              className={`pricing-cta ${tier.highlight ? 'pricing-cta-primary' : 'pricing-cta-secondary'}`}
              onClick={() => onSelectTier(tier.name)}
            >
              {selectedTier === tier.name ? 'Selected' : `Choose ${tier.name}`}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default PricingTable;
